module.exports = __webpack_public_path__ + "img/box_bg.fa75393c.jpg";